var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-main',[_c('div',{staticClass:"fill-height background-gradient-image",staticStyle:{"overflow":"auto"}},[_c('v-container',{staticClass:"pt-10 container px-0 px-sm-3"},[_c('os-sheet',{staticClass:"sheet"},[_c('router-view')],1)],1)],1)]),_c('os-global-dialogs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }